import { lazy } from "react";

export const LessonPage = lazy(() => import("./lessonPage"));
